import { css, SerializedStyles } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ColumnOutput } from '../utils';
import { TableRow } from './table-row';

type RowProps<T extends object> = {
  data: T;
  index?: number;
  startColumn?: (item: T) => React.ReactNode;
  rowHeader?: (item: T) => React.ReactNode;
  colConfig: ColumnOutput<T>[];
  onClick?: (item: T) => void;
  styles?: SerializedStyles;
  endColumn?: (item: T) => React.ReactNode;
};
export const InfiniteRow = <T extends object>({
  data,
  index,
  startColumn,
  rowHeader,
  colConfig,
  onClick,
  styles,
  endColumn,
}: RowProps<T>) => {
  return (
    <div
      key={index}
      css={[
        css`
          display: flex;
          gap: ${theme.spacing(2)};
          padding: ${theme.spacing(3, 3)};
          border-bottom: 1px solid ${theme.colors.neutral10};
          &:hover {
            background-color: ${theme.colors.neutral5};
            cursor: pointer;
          }
        `,
        styles,
      ]}
      onClick={() => {
        if (onClick) {
          onClick(data);
        }
      }}
    >
      {startColumn && (
        <div
          css={css`
            align-self: center;
          `}
          className='start-column'
        >
          {startColumn(data)}
        </div>
      )}
      <div
        css={css`
          flex: 1;
        `}
      >
        <div
          css={css`
            margin-bottom: ${theme.spacing(2)};
          `}
          className='row-header'
        >
          {rowHeader ? rowHeader(data) : null}
        </div>
        <TableRow data={data} colConfig={colConfig} />
      </div>
      {endColumn && (
        <div
          css={css`
            align-self: center;
          `}
          className='end-column'
        >
          {endColumn(data)}
        </div>
      )}
    </div>
  );
};
